import {inject, Injectable, Output, EventEmitter} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, map, Observable} from 'rxjs';
import {RetailerProfileInterface, retailerShortInterface} from '../../profiles/dashboard/dashboard.interface';
import {environment} from '../../../environments/environment';
// import {LoaderService} from '../loader/loader.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private http: HttpClient = inject(HttpClient);
  // private loader: LoaderService = inject(LoaderService);
  private dashboardDataURI = `${environment.backend_base}main/retailer/get_profile/`;
  private publicDashboardDataURI = `${environment.backend_base}main/retailer/get_public_profile/`;

  // private temp = 'assets/temp/retailer-profile-json-example-2.json';
  @Output() compareTo: EventEmitter<any> = new EventEmitter
  private profile:any = null;
  private compareAgainst:BehaviorSubject<retailerShortInterface|null> = new BehaviorSubject<retailerShortInterface|null>(null);

  loadDashboardData(slug: string | null, rcl: string | null, compareRCL: string | null): Observable<RetailerProfileInterface> {
    // if ( !environment.production ) {
    //   return this.http.get<RetailerProfileInterface>(this.temp);
    // }
    // console.log(rcl, slug)
    if (slug || rcl) {
      return this.http.post<{message: string, data: RetailerProfileInterface}>(this.dashboardDataURI, {rcl, slug, compareRCL})
        .pipe(
          map(({data}) => data)
        );
    }
    throw new Error('slug or id not provided');
  }

  loadPublicDashboardData(slug: string | null, rcl: string | null, compareRCL: string | null): Observable<RetailerProfileInterface> {
    // if ( !environment.production ) {
    //   return this.http.get<RetailerProfileInterface>(this.temp);
    // }
    // console.log(rcl, slug)
    if (slug || rcl) {
      return this.http.post<{message: string, data: RetailerProfileInterface}>(this.publicDashboardDataURI, {rcl, slug, compareRCL})
        .pipe(
          map(({data}) => data)
        );
    }
    throw new Error('slug or id not provided');
  }


  compareEmit() {
    this.compareTo.emit()
  }

  setProfile(profile:any) {
    this.profile = profile
  }

  getProfile() {
    return this.profile
  }

  getCompareAgainst() {
    return this.compareAgainst.value
  }

  setCompareAgainst(value:retailerShortInterface) {
    this.compareAgainst.next(value)
  }

}
